module.exports = __webpack_public_path__ + "img/arrow-right.a8fac532.svg";